import { gql, useMutation } from '@apollo/client';
import { EMPLOYEE_FIELDS, Employee } from '@dieterApi/user/useUserQuery';

const ARCHIVE_EMPLOYEE = gql`
  ${EMPLOYEE_FIELDS}
  mutation archiveEmployee($employeeId: String!) {
    archiveEmployee(employeeId: $employeeId) {
      ...UserEmployeeFields
    }
  }
`;

export interface ArchiveEmployeeResult {
  archiveEmployee: Employee;
}

export interface ArchiveEmployeeInput {
  employeeId: string;
}

export function useEmployeeArchiveMutation() {
  return useMutation<ArchiveEmployeeResult, ArchiveEmployeeInput>(ARCHIVE_EMPLOYEE);
}
